import i18n from "@/i18n";

export const playerMonitorPlayersFields = [
    {
        key: "name",
        label: i18n.t("common.name"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "playerId",
        label: i18n.t("playerMonitors.playerId"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "actions",
        label: ""
    }
];
